import React from 'react';
import {LOGO_IMAGE, LOGO_IMAGE_N} from 'app/consts';
import {configStore} from 'app/store/global';
import LogoLink from 'site_version/common/LogoLink';

const logoLink = (onClick?: () => void): JSX.Element => <LogoLink
    logo_image={configStore.CONFIG?.new_year_theme ? LOGO_IMAGE_N : LOGO_IMAGE}
    alt="EGB.com"
    title="EGB.COM"
    onClick={onClick}
/>;
export default logoLink;
